/*
  Boutons 3D harmonisés (2026-10-13) : applique .plm-btn3d aux boutons PLEINS du site en gardant leur couleur.
  Les boutons à contour (fond transparent), les flèches et les liens d'évitement ne sont pas concernés.
*/
(function () {
  var SELECTOR = [
    '.button:not(.button--secondary):not(.button--tertiary):not(.skip-to-content-link):not(.slider-button)',
    '.local-seo__button', '.local-seo__service-button', '.local-seo__desktop-call', '.tarifs-shared__service-link',
    '.plm-avis__btn', '.prestation-next-step__button',
    '.plm-button--primary', '.pmp-btn--primary', '.plm-home-button'
  ].join(',');

  function parseColor(value) {
    var m = String(value || '').match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+%?))?/);
    if (!m) return null;
    var a = m[4] === undefined ? 1 : (m[4].indexOf('%') > 0 ? parseFloat(m[4]) / 100 : parseFloat(m[4]));
    return { r: +m[1], g: +m[2], b: +m[3], a: a };
  }
  function baseColor(cs) {
    // Fond en dégradé (pages de prestation, bouton téléphone foncé) : c'est lui qu'on voit -> couleur du milieu.
    var all = String(cs.backgroundImage || '').match(/rgba?\([^)]*\)/g);
    if (all && all.length) { var mid = parseColor(all[Math.floor((all.length - 1) / 2)]); if (mid && mid.a > 0.5) return mid; }
    var c = parseColor(cs.backgroundColor);
    return c && c.a > 0.5 ? c : null;
  }
  function shade(c, k, a) { return 'rgba(' + Math.round(c.r * k) + ',' + Math.round(c.g * k) + ',' + Math.round(c.b * k) + ',' + a + ')'; }

  function upgrade(el) {
    if (el.__plmBtn || el.classList.contains('plm-btn3d')) return;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || el.closest('.visually-hidden')) return;
    var c = baseColor(cs);
    if (!c) return; // bouton à contour (ou styles pas encore chargés) : inchangé, revérifié plus tard
    el.__plmBtn = true;
    el.style.setProperty('--plm-btn-bg', 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')');
    // Tranche : teinte foncée semi-transparente du bouton (référence prestation : rgba(112,62,42,.30)).
    el.style.setProperty('--plm-btn-ledge', shade(c, 0.58, 0.32));
    var st = el.style;
    st.setProperty('background-color', 'var(--plm-btn-bg)', 'important');
    st.setProperty('background-image', 'var(--plm-btn-sheen)', 'important');
    st.setProperty('border', '1px solid var(--plm-btn-border)', 'important');
    st.setProperty('box-shadow', 'var(--plm-btn-shadow)', 'important');
    st.setProperty('transform', 'var(--plm-btn-move)', 'important');
    st.setProperty('filter', 'var(--plm-btn-filter)', 'important');
    st.setProperty('transition', 'transform .16s ease, box-shadow .16s ease, filter .16s ease', 'important');
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) st.setProperty('transition', 'none', 'important');
    var before = getComputedStyle(el, '::before').content;
    if (before && before !== 'none' && before !== '""' && before !== "''") el.classList.add('plm-btn3d--nogloss');
    el.classList.add('plm-btn3d');
  }
  function run(root) { (root || document).querySelectorAll(SELECTOR).forEach(upgrade); }

  function start() {
    run();
    // Certains styles de section arrivent après le DOM (transitions, feuilles différées) : nouvelles passes.
    window.addEventListener('load', function () { run(); setTimeout(run, 1500); });
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return; pending = true;
        requestAnimationFrame(function () { pending = false; run(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
